import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const FloatingipIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M10,1.66c4.7,0,8.51,3.81,8.51,8.51h1.49C20,4.65,15.52.17,10,.17S0,4.65,0,10.17h1.49C1.49,5.47,5.3,1.66,10,1.66Z" />
  <path d="M10,4.67c3.04,0,5.5,2.46,5.5,5.5h1.57c0-3.91-3.17-7.07-7.07-7.07s-7.07,3.17-7.07,7.07h1.57c0-3.04,2.46-5.5,5.5-5.5Z" />
  <path d="M14.03,18.44l-1.39,1.39-2.62-2.62-2.62,2.62-1.39-1.39,3.03-3.03v-3.07c-.82-.37-1.4-1.21-1.4-2.17,0-1.32,1.07-2.38,2.38-2.38s2.38,1.07,2.38,2.38c0,.96-.57,1.79-1.4,2.17v3.07l3.03,3.03Z" />
 </svg>,
 "Floatingip"
);
